import axios from 'axios';

const encoder = new TextEncoder();
const data = encoder.encode(import.meta.env.VITE_API_KEY);
const base64 = btoa(String.fromCharCode(...data));
const token = base64;

const authentication = () => {
  const reqData = {
      grant_type: 'client_credentials'
  };
  return axios({
      method: 'post',
      url: `${import.meta.env.VITE_API_BASEURL}oauth/token`,
      withCredentials: true,
      crossdomain: true,
      data: reqData,
      headers: {
          Authorization: `Basic ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded'
      }
  });
};

const refresh = (refreshToken) => {
  const reqData = {
    grant_type: 'refresh_token',
    refresh_token: refreshToken,
  };
  return axios({
    method: 'post',
    url: `${import.meta.env.VITE_API_BASEURL}oauth/token`,
    withCredentials: true,
    crossdomain: true,
    data: reqData,
    headers: {
      Authorization: `Basic ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export { authentication, refresh };
